import { Icon } from "components/icon/Icon";
import { useState } from "react";
import useChatbotStore from "store/chatbot/useChatbotStore";
import useAuthStore from "store/useAuthStore";
import { StyledChatbotButton } from "./style";

export const ChatbotButton = () => {
  const isLogin = useAuthStore((state) => state.isLogin);
  const { isChatbotOpen, setIsChatbotOpen } = useChatbotStore();
  const [isHovered, setIsHovered] = useState(false);

  if (!isLogin) return null;
  return (
    <StyledChatbotButton
      className={`${isChatbotOpen ? "active" : ""}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => setIsChatbotOpen(!isChatbotOpen)}
    >
      <Icon
        strokeWidth={1}
        icon="Stars02"
        size={20}
        stroke="--text-gray-normal"
        fill={isHovered || isChatbotOpen ? "--text-gray-normal" : undefined}
      />
    </StyledChatbotButton>
  );
};
